var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-user", { attrs: { containerClass: "bg-white" } }, [
    _c(
      "form",
      {
        attrs: { autocomplete: "off", method: "post", "data-vv-scope": "form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.login.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12 mt-2 mt-sm-0 mb-4" }, [
            _c("h1", { staticClass: "title text-center text-sm-left" }, [
              _vm._v(_vm._s(this.pageTitle)),
              _c("span", { staticClass: "d-sm-none" }, [
                _c("br"),
                _vm._v("novamente!"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'",
                    },
                  ],
                  staticClass: "city-form-group city-bg form-xl",
                  attrs: {
                    autocomplete: "new-email",
                    type: "text",
                    id: "input-email",
                    name: "email",
                    inputClasses: [
                      "form-control-xl",
                      { "is-invalid": _vm.fnHasError("email") },
                    ],
                    error: _vm.fnFirstError("email"),
                  },
                  model: {
                    value: _vm.form.body.email,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form.body,
                        "email",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.body.email",
                  },
                },
                [_vm._v("\n                    Email\n                ")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: true,
                        min: _vm.getMinPasswordLength(),
                      },
                      expression:
                        "{'required': true, 'min': getMinPasswordLength()}",
                    },
                  ],
                  staticClass: "city-form-group city-bg form-xl",
                  attrs: {
                    autocomplete: "new-password",
                    type: "password",
                    id: "input-password",
                    name: "password",
                    inputClasses: [
                      "form-control-xl",
                      { "is-invalid": _vm.fnHasError("password") },
                    ],
                    error: _vm.fnFirstError("password"),
                  },
                  model: {
                    value: _vm.form.body.password,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form.body,
                        "password",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.body.password",
                  },
                },
                [_vm._v("\n                    Password\n                ")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.errorMsg
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", {
                  staticClass: "alert alert-info",
                  attrs: { role: "alert" },
                  domProps: { innerHTML: _vm._s(_vm.errorMsg) },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row pb-4" }, [
          _c(
            "div",
            {
              staticClass:
                "d-none d-sm-flex col-sm-5 col-lg-6 text-left text-sm-center",
            },
            [
              _c(
                "div",
                { staticClass: "form-check city-form-check pl-2 pl-sm-0" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.staySignedIn,
                        expression: "form.staySignedIn",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "loginFormStaySignedIn" },
                    domProps: {
                      checked: Array.isArray(_vm.form.staySignedIn)
                        ? _vm._i(_vm.form.staySignedIn, null) > -1
                        : _vm.form.staySignedIn,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.form.staySignedIn,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "staySignedIn",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "staySignedIn",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "staySignedIn", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "loginFormStaySignedIn" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "font-small-sm-only text-nowrap" },
                        [_vm._v("Manter sessão")]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-sm-7 col-lg-6 text-center text-sm-right mb-sm-3",
            },
            [
              _c(
                "router-link",
                { attrs: { to: { name: `${_vm.pageID}.resetpassword` } } },
                [
                  _c("span", { staticClass: "font-small-sm-only" }, [
                    _vm._v("Esqueceu-se da password?"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row justify-content-center no-gutters pt-sm-3" },
          [
            _c("div", { staticClass: "col-12 col-sm-12 text-center mx-auto" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-main btn-rounded btn-lg btn-responsive btn-block z-depth-0 mt-4 mb-3 my-lg-5 mx-0",
                  attrs: { type: "submit", disabled: _vm.isDisabled },
                },
                [_vm._v("\n                    Entrar\n                ")]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.$router.resolve({ name: `${_vm.pageID}.register` }).resolved.matched
          .length > 0
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-12 text-center mx-auto mb-3 my-sm-5",
                },
                [
                  _c(
                    "span",
                    { staticClass: "font-small-sm-only d-none d-sm-inline" },
                    [_vm._v("Ainda não tem uma conta?")]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "pl-sm-3",
                      attrs: { to: { name: `${_vm.pageID}.register` } },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "font-small-sm-only d-none d-sm-inline",
                        },
                        [_vm._v("Criar conta")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-main btn-rounded btn-lg btn-responsive btn-block z-depth-0 d-block d-sm-none",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm._v(
                            "\n                            Criar conta\n                        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }